import { Button, Form, Input, Space } from 'antd';

import { FormItemField } from '@app/components/FormFields';
import { OFF, PREFIX } from '@app/constants';

import {
  useBranchMedicalExtension,
  useBranchMedicalExtensionEffects,
} from '../hooks';

import type { BranchMedicalExtensionProps } from '../types';

export const BranchMedicalExtension = ({
  branchId,
}: BranchMedicalExtensionProps) => {
  const { isDataLoading, data } = useBranchMedicalExtensionEffects({
    branchId,
  });
  const { form, isLoading, handleFinish } = useBranchMedicalExtension({
    branchId,
    data,
  });

  return (
    <div className={`${PREFIX}patient-card`}>
      <Form
        form={form}
        layout="vertical"
        clearOnDestroy
        autoComplete={OFF}
        className={`${PREFIX}form`}
        onFinish={handleFinish}
        disabled={isLoading || isDataLoading}
      >
        <Space direction="vertical" size="middle">
          <FormItemField
            label="OID структурного подразделения по справочнику ФРМО"
            fieldName="FrmoOid"
          >
            <Input
              size="large"
              maxLength={100}
              disabled={isLoading || isDataLoading}
            />
          </FormItemField>

          <Button
            type="primary"
            htmlType="submit"
            className="action-button"
            loading={isLoading}
            disabled={isDataLoading}
            size="large"
          >
            Сохранить
          </Button>
        </Space>
      </Form>
    </div>
  );
};
